import { ReactNode } from 'react';
import { BoxProps, Text } from '@keyslabor/shared/ui';

// TODO: Remove any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function columnCell<T = any, R = any>(
  children?: (row: T, record: R) => ReactNode,
  boxProps?: BoxProps
) {
  // TODO: Remove any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function render(row: any, record: any) {
    if (!row) return '';

    return children ? (
      children(row, record)
    ) : (
      <Text fontWeight="400">{row}</Text>
    );
  };
}
